<template>
    <div class="flex h-full w-full">
    <card :to="to" class="w-full" :style="{borderTop: `2px solid ${color}`}">
        <cdn-background-image v-if="src" :src="src" :width="400" :ratio="400/100" :blur="blur" cover>
			<template v-if="$slots.default || badge" #default>
				<slot/>
				<badge v-if="badge" rounded spaced color="secondary" class="absolute top-0 right-0 m-4 shadow">{{ badge }}</badge>
			</template>
        </cdn-background-image>
        <aspect-ratio-box v-else :ratio="4" class="w-full relative">
            <div class="w-full h-full opacity-75" :style="{backgroundColor: color ?? $config.public.colors.secondary}"/>
            <slot/>
        </aspect-ratio-box>

        <div class="flex items-center justify-center py-8" :style="{borderTop: `1px solid ${color}`}">
            <p v-if="title" class="text-2xs sm:text-xs leading-normal truncate mb-0" :style="{color: color}">
                {{ title }}</p>
            <icon v-if="to && typeof to === 'string' && to.startsWith('http')" :icon="icons.external_link" color="gray-300" class="absolute right-0 mx-8" xx-small/>
        </div>
    </card>
    </div>
</template>

<script>
import {externalLinkIcon} from "@spoferan/nuxt-spoferan/icons";

export default {
    name: "ImageWidget",

    props: {
		to: {
			type: [String, Object],
			default: null
		},

        src: {
            type: [String, Object],
            default: null
        },

        // The title text to show below the icon for every size
        title: {
            type: String,
            default: null
        },

        // The description to show below the title for sizes >= 2x2
        description: {
            type: String,
            default: null
        },

        color: {
            type: String,
            default: null
        },

        // The blur density to add to the image style
        blur: {
            type: Number,
            default: null
        },

		badge: {
			type: String,
			default: null
		}
    },

	data() {
		return {
			icons: {
				external_link: externalLinkIcon
			}
		}
	}
}
</script>